const FEATURES = [
  {
    icon: 'ri-speed-up-line',
    title: '极速不缓冲',
    desc: '先进的CDN加速与自适应码率技术，确保高清视频流畅播放，告别卡顿等待。',
    color: 'bg-primary-100 text-primary-500',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全平台适配',
    desc: '同时支持手机、平板、电脑，响应式设计自动适配不同屏幕，无缝切换观影设备。',
    color: 'bg-accent-100 text-accent-500',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日同步更新',
    desc: '自动同步香蕉视频、蜜桃视频、西瓜视频、樱花视频等七大平台最新内容，永不掉队。',
    color: 'bg-secondary-100 text-secondary-500',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全可靠',
    desc: '所有内容均来自正规合作平台，无需注册账号，无隐私泄露风险，安心观影。',
    color: 'bg-primary-100 text-primary-500',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-2">
          特色优势
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-8 md:mb-10">
          为什么选择妖精视频
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {FEATURES.map((feat) => (
            <div
              key={feat.title}
              className="text-center p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 hover:border-accent-200 transition-all duration-300"
            >
              <div className={`w-12 h-12 rounded-xl flex items-center justify-center mx-auto mb-4 ${feat.color}`}>
                <i className={`${feat.icon} text-xl`}></i>
              </div>
              <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-2">
                {feat.title}
              </h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}